<!-- @format -->

<template>
  <Layout>
    <div v-if="selectedAccident.id">
      <div class="row">
        <div>
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-3">
                  <button type="button" onclick="history.back()" class="btn btn-sm btn-outline-primary">
                    <i class="bx bx-chevron-left"></i>
                  </button>
                </div>

                <div class="col-9 text-end">
                  <button type="button" @click="editAcciDetails" class="btn btn-sm btn-primary me-2">
                    <i class="mdi mdi-pencil"></i> Edit Details
                  </button>
                  <button type="button" @click="trackRpoIncident" class="btn btn-sm btn-primary me-2">
                    <i class="mdi mdi-car"></i> Track RPO
                  </button>
                  <template>
                    <button type="button" v-if="selectedAccidentStatus.status === 'Open'" @click="resolveAccident"
                      class="btn btn-sm btn-primary me-2">
                      <i class="mdi mdi-Flag"></i> Resolve Accident
                    </button>
                  </template>
                  <button :class="`btn btn-sm ${statusColor}`">
                    Status: {{ selectedAccident.status }}
                  </button>
                  <button type="button" class="btn btn-sm btn-primary ms-2">
                    <i class="mdi mdi-map-marker"></i> Open Map
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body row">
              <hr />
              <div class="table-responsive col-6">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Accident Id</th>
                      <td>{{ selectedAccident.id }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Source</th>
                      <td>{{ selectedAccident.source_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Chainage Number</th>
                      <td>
                        {{
                          selectedAccident.ch_no != null ? selectedAccident.ch_no : "NA"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Side</th>
                      <td>
                        {{ selectedAccident.side != null ? selectedAccident.side : "NA" }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle Involved</th>
                      <td></td>
                    </tr>

                    <tr>
                      <th scope="row">Accident Date/Time</th>
                      <td>
                        {{
                          new Date(selectedAccident.incident_datetime).toLocaleString()
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Reported Date/Time</th>
                      <td>
                        {{
                          new Date(selectedAccident.reported_datetime).toLocaleString()
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Close Date/Time</th>
                      <td>
                        {{ new Date(selectedAccident.close_datetime).toLocaleString() }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Assigned To</th>
                      <td>
                        {{
                          selectedAccident.reported_to_name != null
                            ? selectedAccident.reported_to_name
                            : "NA"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-responsive col-6">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Nature of Accident</th>
                      <td>
                        {{
                          selectedAccident.nature_of_accident != null
                            ? selectedAccident.nature_of_accident
                            : "NA"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Reason of Accident</th>
                      <td>
                        {{
                          selectedAccident.reason_of_accident != null
                            ? selectedAccident.reason_of_accident
                            : "NA"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Nature of Injury</th>
                      <td>
                        {{
                          selectedAccident.nature_of_injury != null
                            ? selectedAccident.nature_of_injury
                            : "NA"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Arrival Time Of RPV</th>
                      <td></td>
                    </tr>
                    <tr>
                      <th scope="row">Arrival Time Of Ambulance</th>
                      <td></td>
                    </tr>
                    <tr>
                      <th scope="row">Arrival Time Of Crane</th>
                      <td></td>
                    </tr>
                    <tr>
                      <th scope="row">Description</th>
                      <td>
                        {{
                          selectedAccident.description != null
                            ? selectedAccident.description
                            : "NA"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Action Taken</th>
                      <td></td>
                    </tr>
                    <tr>
                      <th scope="row"></th>

                      <td class="float-end">
                        <button type="button" @click="$router.push('/rpo-details')" class="btn btn-sm btn-warning me-2">
                          <i class="mdi mdi-account-check"></i> RPO Details
                        </button>
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Incident Vehicle Details -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Vehicle Details</h4>
              <hr />
            </div>
            <div class="text-center" v-if="items.length === 0">
              <p>No vehicles added</p>
            </div>
            <div class="row" v-else>
              <div class="col-12">
                <div class="mb-3">
                  <b-table-lite :items="items" :fields="fields">
                    <template #cell(actions)="row">
                      <b-button size="sm" variant="primary" class="m-1" @click="editVehicleDetails(row.item)">View
                      </b-button>
                    </template>
                  </b-table-lite>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Incident Photos details -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">{{ selectedAccident.category_name }} Photos</h4>
              <hr />
              <div class="text-center" v-if="incidentImages.length === 0">
                <p>No images added</p>
              </div>

              <div v-else>
                <img v-for="(src, index) in incidentImages" :key="index" class="float-left image mb-2"
                  @click="() => showCaptiomImg(index)" width="150" :src="src"
                  style="margin-right: 10px; cursor: pointer" />
              </div>
            </div>
            <vue-easy-lightbox :visible="visibleCaption" :imgs="incidentImages" :index="index"
              @hide="handleCaptionHide"></vue-easy-lightbox>
          </div>
        </div>
      </div>

      <!-- Edit vehicle details -->
      <b-modal id="edit-vehicle-details-modal" title="Edit Vehicle Details" title-class="font-18" hide-footer
        no-close-on-backdrop size="xl">
        <template #modal-header>
          <div>
            <h5>Vehicle Details</h5>
          </div>
          <div>
            <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('edit-vehicle-details-modal')">
              Cancel
            </button>
          </div>
        </template>
        <div>
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Driver Name</th>
                      <td>{{ selectedVehicle.driver_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle No.</th>
                      <td>{{ selectedVehicle.vehicle_no }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Vehicle Class</th>
                      <td>{{ vehicleClass }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Mobile No.</th>
                      <td>{{ selectedVehicle.mobile_no }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Driver Address</th>
                      <td>{{ selectedVehicle.driver_address }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Origin of Vehicle</th>
                      <td>{{ selectedVehicle.origin }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Point of Arrival</th>
                      <td>{{ selectedVehicle.arrival }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Destination of Vehicle</th>
                      <td>{{ selectedVehicle.destination }}</td>
                    </tr>
                    <tr>
                      <th scope="row">No. of Passengers</th>
                      <td>{{ selectedVehicle.passenger_count }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- Track RPO modal -->
      <b-modal id="Track-RPO-Modal" title="RPO and Incident Live Tracker" title-class="font-18" size="xl" hide-footer
        centered no-close-on-esc no-close-on-backdrop>
        <template #modal-header>
          <div>
            <h5>RPO and Incident Live Tracker</h5>
          </div>
          <div>
            <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('Track-RPO-Modal')">
              <i class="mdi mdi-close"></i>
            </button>
          </div>
        </template>
        <div class="row">
          <div class="col-5">
            <p class="mb-2">
              Incident ID:
              <span class="text-primary">{{ selectedRpoIncident.id }}</span>
            </p>
            <p class="mb-2">
              Vehicle Number:
              <span class="text-primary">{{
                selectedRpoIncident.vehicle_no
                  ? selectedRpoIncident.vehicle_no
                  : "Not available"
              }}</span>
            </p>
            <p class="mb-4">
              Date | Time:
              <span class="text-primary">{{
                new Date(selectedRpoIncident.incident_datetime).toLocaleString()
              }}</span>
            </p>
            <hr />

            <h5>
              <i class="bx bxs-video-recording text-danger font-size-18 bx-fade-right"></i>
              <span class="m-3">Live</span>
            </h5>
            <div class="row" v-if="rpoDeviceStats">
              <div class="col-6">
                <button v-if="rpoGPS" :class="rpoGPS.status
                  ? 'btn btn-sm w-100 btn-success m-2'
                  : 'btn btn-sm w-100 btn-danger m-2'
                  ">
                  RPO GPS Location
                </button>
              </div>
              <div class="col-6">
                <button v-if="rpoFrontCamera" :class="rpoFrontCamera.status
                  ? 'btn btn-sm w-100 btn-success m-2'
                  : 'btn btn-sm w-100 btn-danger m-2'
                  ">
                  RPV Front Camera
                </button>
              </div>
              <div class="col-6">
                <button v-if="rpoRearCamera" :class="rpoRearCamera.status
                  ? 'btn btn-sm w-100 btn-success m-2'
                  : 'btn btn-sm w-100 btn-danger m-2'
                  ">
                  RPV Rear Camera
                </button>
              </div>
              <div class="col-6">
                <button v-if="rpoBodyCamera" :class="rpoBodyCamera.status
                  ? 'btn btn-sm w-100 btn-success m-2'
                  : 'btn btn-sm w-100 btn-danger m-2'
                  ">
                  RPO Body Camera
                </button>
              </div>
            </div>
            <div class="text-center" v-else>
              <p class="text-danger">RPO Device is Offline</p>
            </div>
            <hr />
            <ul class="verti-timeline list-unstyled">
              <li class="event-list active">
                <div class="event-timeline-dot">
                  <i class="bx bxs-right-arrow-circle font-size-18 bx-fade-right"></i>
                </div>
                <div class="d-flex">
                  <div class="me-3">
                    <h5 class="font-size-14">
                      Incident Closed
                      <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div class="flex-grow-1">
                    <div>14/03/2023 - 18:05:19</div>
                  </div>
                </div>
              </li>
              <li class="event-list">
                <div class="event-timeline-dot">
                  <i class="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div class="d-flex">
                  <div class="me-3">
                    <h5 class="font-size-14">
                      RPO Reported
                      <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div class="flex-grow-1">
                    <div>14/03/2023 - 17:56:10</div>
                  </div>
                </div>
              </li>
              <li class="event-list">
                <div class="event-timeline-dot">
                  <i class="bx bx-right-arrow-circle font-size-18"></i>
                </div>
                <div class="d-flex">
                  <div class="me-3">
                    <h5 class="font-size-14">
                      Incident Created
                      <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
                    </h5>
                  </div>
                  <div class="flex-grow-1">
                    <div>14/03/2023 - 17:40:37</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-7">
            <h5>RPO Activity Tracking</h5>
            <GoogleMap v-if="rpoDeviceStats" :location="rpoGPS" />
            <div class="text-center" v-else>
              <p class="text-danger mt-5">
                Unable to load location. RPO Device is Offline.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div v-else>
      <widgetLoader></widgetLoader>
    </div>

    <EditAccidentDeatailsModal :editAccidentObj="editAccident" @reload="reloadAfterEdit"></EditAccidentDeatailsModal>

  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import incidentMixin from "../../mixins/incident";
import VueEasyLightbox from "vue-easy-lightbox";
import SectionSpeed from "@/components/incidents/section-speed";
import widgetLoader from "@/components/widgets/widget-loader";
import EditAccidentDeatailsModal from "../../modals/edit-accident-details-modal.vue";
import GoogleMap from "@/components/incidents/google-map";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Incident Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [incidentMixin],
  props: {
    accidentId: String,
  },

  components: {
    Layout,
    PageHeader,
    VueEasyLightbox,
    SectionSpeed,
    widgetLoader,
    EditAccidentDeatailsModal,
    GoogleMap,


  },

  data() {
    return {
      selectedAccident: {},
      editAccident: {},
      visibleCaption: false,
      index: 1,
      vehicleNumber: null,
      items: [],
      selectedVehicle: {},
      selectedRpoIncident: {},
      rpoDeviceStats: null,
      vehicleClass: null,
      selectedAccidentStatus: {
        status: "Open",
      },

      options: {
        vehicleClass: [],
        offenceId: [],
        districtCode: [],
        stateCode: [],
        dpCd: [{ name: "TD" }, { name: "TR" }],
        violationSrc: [{ name: "SLV" }, { name: "RLV" }],
        subCategory: [],
        informedTo: [],
      },
      fields: [
        {
          key: "driver_name",
          label: "Driver Name",
          sortable: true,
        },
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "mobile_no",
          label: "Mobile No.",
          sortable: false,
        },
        {
          key: "passenger_count",
          label: "No. of Passengers",
          sortable: false,
        },
        {
          key: "driver_address",
          label: "Driver Address",
          sortable: false,
        },
        {
          key: "actions",
        },
      ],
    };
  },

  methods: {
    async reloadAfterEdit() {
      this.selectedAccident = await this.AccidentDetailsById(this.accidentId);
      this.showVehicles(this.selectedAccident.id);
    },
    resolveAccident() {
      const accidentId = this.selectedAccident.id;
      this.$router.push(`/incident/resolve-accident/${accidentId}`);
    },

    async onInput(e) {
      this.vehicleNumber = await e.target.innerText;
    },

    sendNotificationToRPO() {
      this.$bvModal.show("select-rpo-modal");
    },

    informedToRpo() {
      Swal.fire(
        "RPO Selected!",
        "RPO has been selected and notifications have been sent.",
        "success"
      ).then(() => {
        this.$bvModal.hide("select-rpo-modal");
      });
    },

    async getIncidentMasters() {
      try {
        const incidents = await this.GetIncidentMasters();
        this.options.vehicleClass = incidents.getVehicleClass;
        this.options.offenceId = incidents.getOffenceId;
        this.options.districtCode = incidents.getDistrictCode;
        this.options.stateCode = incidents.getStateCode;
        this.options.subCategory = incidents.getIncidentSubCategory;
        this.options.informedTo = incidents.rpoData;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async showVehicles(id) {
      const body = {
        id: id,
      };
      this.items = await this.ShowVehicleDetails(body);
    },

    editVehicleDetails(vehicle) {
      this.selectedVehicle = vehicle;
      if (this.selectedVehicle.vehicle_class_id) {
        const vehicleClass = this.options.vehicleClass.find(
          (vehicleClass) => vehicleClass.id === this.selectedVehicle.vehicle_class_id
        );
        this.vehicleClass = vehicleClass.class_name;
      }
      this.$bvModal.show("edit-vehicle-details-modal");
    },

    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide() {
      this.visibleCaption = false;
    },

    getReadableDateTime(dateTime) {
      if (dateTime) {
        // const date = String(dateTime).split("T");
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },

    challanGenerated() {
      Swal.fire(
        "Challan Generated",
        "Challan has been raised to this incident",
        "success"
      )
        .then(() => {
          this.$bvModal.hide("raise-challan-modal");
        })
        .then(() => {
          const btn = document.getElementById(
            `${this.currentChallanModalId - 1}-raise-challan-btn`
          );
          if (btn) {
            this.currentChallanModalId = this.currentChallanModalId - 1;
            btn.click();
          }
        });
    },

    async updateIncidentDetails() {
      const vehicleClass = this.options.vehicleClass.find(
        (vehicleClass) => vehicleClass.class_name === this.selectedAccident.class_name
      );

      let informedToId = null;

      if (this.selectedAccident.reported_to_name) {
        const splitInformedTo = this.selectedAccident.reported_to_name.split(" ");
        const firstName = splitInformedTo.shift(0);

        const informedTo = this.options.informedTo.find(
          (name) => name.firstName === firstName
        );
        informedToId = informedTo.id;
      }

      let getVehicleNumber = null;

      if (this.vehicleNumber) {
        getVehicleNumber = this.vehicleNumber;
      } else {
        getVehicleNumber = this.selectedAccident.vehicle_no;
      }

      await this.incidentSaved();
      const body = {
        id: this.selectedAccident.id,
        vehicle_no: getVehicleNumber,
        vehicle_class_id: vehicleClass.id,
        reported_to: informedToId,
      };
      await this.UpdateVehicleNumber(body);
    },

    async convertIncidentToAccident() {
      const body = {
        id: this.selectedAccident.id,
      };

      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, convert it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.ConvertIncidentToAccident(body);
          Swal.fire("Converted!", "This Incident converted into Accident.", "success");
        }
      });
    },

    incidentSaved() {
      Swal.fire("Saved", "Incident details updated successfully", "success").then(() => {
        this.$bvModal.hide("more-details-modal");
        this.$bvModal.hide("raise-challan-modal");
      });
    },

    async generateChallan() {
      try {
        let images = [];
        for (let image of this.selectedAccident.images) {
          images.push(image.media_url);
        }

        const body = {
          incidentId: this.selectedAccident.id,
          id: "2",
          offenceId: this.offenceId,
          dpCd: this.dpCd,
          latitude: this.selectedAccident.lat,
          transactionNo: this.selectedAccident.transaction_id,
          userId: "1",
          regnNo: this.selectedAccident.vehicle_no,
          voilationSource: this.voilationSource,
          voilationSourceCatg: this.selectedAccident.sub_category_name,
          stateCd: this.stateCd,
          districtId: this.districtId,
          location: this.selectedAccident.location,
          offCd: 55,
          equipmentId: this.selectedAccident.camera_id,
          vendorName: "VEH",
          vehicleSpeed: parseInt(this.vehicleSpeed),
          speedLimit: this.selectedAccident.speed_limit,
          vehicleWeight: 0,
          voilationTime: this.selectedAccident.incident_datetime,
          actionTime: new Date(),
          longitude: this.selectedAccident.long,
          images: images,
        };
        await this.GenerateChallan(body);
        await this.updateIncidentDetails();
        await this.challanGenerated();
        this.$bvModal.hide("more-details-modal");
      } catch (e) {
        console.error(e);
        Swal.fire("Challan Generation Failed", e.response.data.message, "error");
      }
    },

    editAcciDetails() {
      // alert(" Edit Accident details modal is opened");

      this.editAccident = this.selectedAccident;
      console.log(this.editAccident);
      this.$bvModal.show("Acci-Details-Modal");
    },

    trackRpoIncident() {
      // alert(" track RPO modal is opened");
      this.selectedRpoIncident = this.selectedAccident;
      console.log(this.selectedRpoIncident);
      this.$bvModal.show("Track-RPO-Modal");
    }
  },

  computed: {
    masters() {
      return this.$store.getters["incident/masters"];
    },
    incidentImages() {
      return this.selectedAccident.images
        ? this.selectedAccident.images.map((e) => e.media_url)
        : [];
    },
    statusColor() {
      switch (this.selectedAccident.status) {
        case "Resolved":
          return "btn-outline-success";

        default:
          return "btn-outline-warning";
      }
    },

    rpoFrontCamera() {
      return !this.rpoDeviceStats
        ? false
        : this.rpoDeviceStats.find((a) => a.name === "front_camera_url");
    },
    rpoRearCamera() {
      return !this.rpoDeviceStats
        ? false
        : this.rpoDeviceStats.find((a) => a.name === "rear_camera_url");
    },
    rpoBodyCamera() {
      return !this.rpoDeviceStats
        ? false
        : this.rpoDeviceStats.find((a) => a.name === "body_camera_url");
    },
    rpoGPS() {
      return !this.rpoDeviceStats
        ? false
        : this.rpoDeviceStats.find((a) => a.name === "GPS");
    },
  },

  async mounted() {
    await this.getIncidentMasters();
  },

  async created() {
    this.selectedAccident = await this.AccidentDetailsById(this.accidentId);
    this.showVehicles(this.selectedAccident.id);
  },
};
</script>
